import { useToast, Text, Flex } from '@chakra-ui/react'
import PageTransition from '../components/PageTransition'
import { ErrorBoundary } from 'react-error-boundary'
import Header from '../Header'
import WidgetWrapper from './WidgetWrapper'
import QuoteDisplay from './QuoteDisplay'
import FAQSection from './FAQSection'
import TPIGuide from './TPIGuide'

const Dashboard = ({ ticker = 'MSTY', subtitle = 'Strategy Options Fund (MSTY) - Comprehensive Analysis' }: { ticker?: string, subtitle?: string }): JSX.Element => {
  const toast = useToast()

  return (
    <>
      <Header title="Chrysalis: Hatching Insights" subtitle={subtitle} />
      <PageTransition>
      <ErrorBoundary
        fallback={<Text color="brand.secondary">Dashboard failed to load</Text>}
        onError={(error: Error) => {
          toast({
            title: 'Error loading dashboard',
            description: error.message,
            status: 'error',
            duration: 5000,
            isClosable: true,
          })
        }}
      >
        <WidgetWrapper>
          <TPIGuide />
        </WidgetWrapper>
        <WidgetWrapper>
          <FAQSection />
        </WidgetWrapper>
        <QuoteDisplay />
        <Flex justify="center" align="center" mt={8} mb={4} color="gray.500" fontSize="sm">
          <Text>Made with </Text>
          <Text color="red.500" mx={1}>♥</Text>
          <Text>in San Francisco </Text>
          <Text mx={1}>©</Text>
          <Text>{new Date().getFullYear()}</Text>
        </Flex>
      </ErrorBoundary>
      </PageTransition>
    </>
  )
}

export default Dashboard
